var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatefile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.117 12.4418H24.8921C24.0327 12.4418 23.3359 11.7451 23.3359 10.8856V4.66083",
    stroke: "#0074B2",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32959 12.4418V7.77324C9.32959 6.0543 10.7231 4.66083 12.442 4.66083H23.6031C24.4285 4.66083 25.22 4.98903 25.8036 5.57276L30.2045 9.97371C30.7882 10.5573 31.1164 11.3488 31.1164 12.1742V29.5601C31.1164 31.279 29.723 32.6725 28.004 32.6725H12.442C10.7231 32.6725 9.32959 31.279 9.32959 29.5601V28.0039",
    stroke: "#0074B2",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2568 17.5991V20.6399L14.6472 22.0966",
    stroke: "#0074B2",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.66113,
    y: 12.4418,
    width: 15.562,
    height: 15.562,
    rx: 3.5,
    stroke: "#0074B2",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatefile);
export default __webpack_public_path__ + "static/media/datefile.716e256eba8329b03eefa148a6e1bc08.svg";
export { ForwardRef as ReactComponent };